import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../../lib/const/constants';
import getCurrencySymbol from '../../lib/currenyUtils';
import {
  // FiArrowDownLeft,
  FiArrowUpRight,
  FiFilter,
  FiEye,
  FiSearch,
  FiChevronLeft,
  FiChevronRight,
  // FiCalendar,
  FiX,
} from 'react-icons/fi';
import { MdOutlineCurrencyExchange, MdDownloading } from 'react-icons/md';
import { HiOutlineArrowDownTray } from 'react-icons/hi2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FILE_SIZE_ERROR, isFileTooLarge } from '../../utils/fileValidation';
import PropTypes from 'prop-types';
import { beneficiaryList } from '../../utils/CommonFunctions';
import { encryptPayload } from '../../utils/encryption';
import { amountFormat } from '../../utils/formatAmount';

const ITEMS_PER_PAGE = 10;

function Transaction({ filtercurrency, fromHome, width }) {
  Transaction.propTypes = {
    filtercurrency: PropTypes.string,
    fromHome: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  const navigate = useNavigate();

  // ── Core data state ────────────────────────────────────────────────────────
  const [transactions, setTransactions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [uiPage, setUiPage] = useState(1);
  const [hoveredRow, setHoveredRow] = useState(null);

  // ── Combined search bar ───────────────────────────────────────────────────
  const [combinedSearch, setCombinedSearch] = useState('');
  const [searchText, setSearchText] = useState({
    transactionId: '',
    date: '',
    sender: '',
    sendingAmount: '',
    receivingAmount: '',
    status: '',
    type: '',
  });
  const debounceRef = useRef(null);
  const txnIdDebounceRef = useRef(null);

  // ── Other UI state ─────────────────────────────────────────────────────────
  const [documents, setdocuments] = useState({});
  const [, setdocUploaded] = useState(false);
  const [showdownload, setshowdownload] = useState(false);
  const [fromdate, setFromdate] = useState('');
  const [todate, setTodate] = useState('');
  const [downloadLoading, setdownloadLoading] = useState(false);
  const [, settransactionIds] = useState([]);
  const [downloadId, setdownloadId] = useState(0);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [, setShowDateDropdown] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState('pdf');
  const filterRef = useRef(null);
  const dateRef = useRef(null);

  // ── Upload state (from first code) ────────────────────────────────────────
  const [showUploadRow, setShowUploadRow] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [uploading, setUploading] = useState(false);

  // ── Balance / beneficiary state ────────────────────────────────────────────
  const [, setBeneficiaries] = useState([]);
  const [, setLastTransaction] = useState();
  const [usedBalances, setusedBalances] = useState([]);
  const [, setBalLoading] = useState(false);
  const [, setcurrencyCloudBalance] = useState(0.0);
  const [, setclearBankBalance] = useState(0.0);
  const [, setclearBankConfiguration] = useState();
  const [, setBalances] = useState([]);
  const [, setreference] = useState();
  const [, setBalance] = useState();

  const account_type = sessionStorage.getItem('account_type');

  // ── Click-outside handler ──────────────────────────────────────────────────
  useEffect(() => {
    const handler = (e) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(e.target) &&
        !dateRef.current?.contains(e.target)
      )
        setShowFilterDropdown(false);
      if (
        dateRef.current &&
        !dateRef.current.contains(e.target) &&
        !filterRef.current?.contains(e.target)
      )
        setShowDateDropdown(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // ── Core fetch (from first code logic) ────────────────────────────────────
  const getData = async (pageNumber, searchParams = searchText) => {
    const login_id = sessionStorage.getItem('login_id');
    const login_token = sessionStorage.getItem('login_token');
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');

    if (!login_id || !login_token) {
      sessionStorage.clear();
      navigate('/business');
      return;
    }

    setLoading(true);

    const from =
      new Date().getFullYear() +
      '-' +
      (new Date().getMonth() + 1) +
      '-' +
      (new Date().getDate() - 100);
    const to =
      new Date().getFullYear() +
      '-' +
      (new Date().getMonth() + 1) +
      '-' +
      new Date().getDate();

    try {
      const senderNorm = encodeURIComponent(
        searchParams.sender?.trim().toLowerCase() || '',
      );

      let geturl = '';
      if (filtercurrency == '' || filtercurrency == null) {
        geturl = `${Constants.BASE_URL}API-FX-180-CONVERSIONLIST/${login_workspaces_id}?page=${pageNumber}&from=${from}&to=${to}&transactionId=${searchParams.transactionId}&date=${searchParams.date}&sender=${senderNorm}&sendingAmount=${searchParams.sendingAmount}&receivingAmount=${searchParams.receivingAmount}&status=${searchParams.status}&type=${searchParams.type}`;
      } else {
        geturl = `${Constants.BASE_URL}API-FX-180-CONVERSIONLIST/${login_workspaces_id}?page=${pageNumber}&from=${from}&to=${to}&currency=${filtercurrency}&transactionId=${searchParams.transactionId}&date=${searchParams.date}&sender=${senderNorm}&sendingAmount=${searchParams.sendingAmount}&receivingAmount=${searchParams.receivingAmount}&status=${searchParams.status}&type=${searchParams.type}`;
      }

      const response = await axios.get(geturl, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(login_token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      });

      const newTransactions = response.data.transactions;
      const otherTransactions = response.data.otherTransactions;
      const combined = [...newTransactions, ...otherTransactions];

      setTransactions((prevTransactions) => {
        const base = pageNumber === 0 ? [] : prevTransactions;

        const merged = [...base, ...combined];

        const deduped = Array.from(
          new Map(merged.map((t) => [t.id, t])).values(),
        );

        sessionStorage.setItem('transactionList', JSON.stringify(deduped));

        return deduped;
      });

      setHasMore(combined.length >= ITEMS_PER_PAGE);

      if (combined.length > 0) {
        setCurrentPage(pageNumber + 1);
      }

      if (Array.isArray(otherTransactions) && otherTransactions.length > 0) {
        const debitTransactions = otherTransactions
          .filter((t) => t.type === 'debit')
          .slice(0, 3);
        const mapped = debitTransactions.map((txn) => {
          const meta = JSON.parse(txn.meta || '{}');
          return {
            id: txn.id,
            name: meta.second_beneficiary_name,
            amount:
              meta.conversion_meta?.conversion_client_sell_amount || txn.amount,
            currency:
              meta.conversion_meta?.conversion_sell_currency ||
              txn.settled_currency,
            date: txn.created_at,
            status: txn.status,
            payment_method: txn.payment_method,
            transfer_reason: meta.conversion_meta?.reason,
            last_transaction: txn,
            meta_data: meta,
            contact_id: meta?.conversion_meta?.conversion_id || null,
          };
        });
        setLastTransaction(mapped[0] || null);
        localStorage.setItem('latestTransactions', JSON.stringify(mapped));
      }

      const mergedData = response.data.typeOfDocuments.reduce(
        (acc, current) => {
          const key = current.transaction_id;
          if (!acc[key]) acc[key] = [];
          acc[key].push(current);
          return acc;
        },
        {},
      );

      setdocuments((prevState) => ({ ...prevState, ...mergedData }));
      setdocUploaded(response.data.docUploaded);
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Smart search routing ───────────────────────────────────────────────────
  const resolveSearchParams = (value) => {
    const trimmed = value.trim();
    const base = { transactionId: '', sender: '', sendingAmount: '' };
    if (!trimmed) return base;
    // if (/^\d{4}$/.test(trimmed)) return { ...base, transactionId: trimmed };
    // if (/^\d+\.\d+$/.test(trimmed)) return { ...base, sendingAmount: trimmed };
    if (/^\d+\.?\d*$/.test(trimmed)) return { ...base, sendingAmount: trimmed };
    return { ...base, sender: trimmed };
  };

  // ── Combined search handler — debounced ───────────────────────────────────
  const handleCombinedSearchChange = useCallback(
    (value) => {
      setCombinedSearch(value);
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        const resolved = resolveSearchParams(value);
        const newParams = { ...searchText, ...resolved };
        setSearchText(newParams);
        setTransactions([]);
        setCurrentPage(0);
        setHasMore(true);
        setUiPage(1);
        getData(0, newParams);
      }, 500);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchText],
  );

  const handleTransactionIdChange = useCallback(
    (value) => {
      const newParams = { ...searchText, transactionId: value };
      setSearchText(newParams);

      if (txnIdDebounceRef.current) clearTimeout(txnIdDebounceRef.current);
      txnIdDebounceRef.current = setTimeout(() => {
        setTransactions([]);
        setCurrentPage(0);
        setHasMore(true);
        setUiPage(1);
        getData(0, newParams);
      }, 500);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchText],
  );

  const clearCombinedSearch = () => {
    setCombinedSearch('');
    const resetParams = {
      transactionId: '',
      date: '',
      sender: '',
      sendingAmount: '',
      receivingAmount: '',
      status: searchText.status,
      type: searchText.type,
    };
    setSearchText(resetParams);
    setTransactions([]);
    setCurrentPage(0);
    setHasMore(true);
    setUiPage(1);
    getData(0, resetParams);
  };

  // ── Full reset ─────────────────────────────────────────────────────────────
  const reset = () => {
    setCombinedSearch('');
    const resetValues = {
      transactionId: '',
      date: '',
      sender: '',
      sendingAmount: '',
      receivingAmount: '',
      status: '',
      type: '',
    };
    setSearchText(resetValues);
    setTransactions([]);
    setCurrentPage(0);
    setHasMore(true);
    setUiPage(1);
    getData(0, resetValues);
  };

  // ── Pagination helpers ─────────────────────────────────────────────────────
  const totalPages = fromHome
    ? 1
    : Math.ceil(transactions.length / ITEMS_PER_PAGE);

  const paginatedTransactions = fromHome
    ? transactions.slice(0, 5)
    : transactions.slice(
        (uiPage - 1) * ITEMS_PER_PAGE,
        uiPage * ITEMS_PER_PAGE,
      );

  const currentPageComplete =
    transactions.length >= uiPage * ITEMS_PER_PAGE || !hasMore;

  const handlePageChange = async (page) => {
    if (page < 1 || pageLoading) return;
    const requiredItems = page * ITEMS_PER_PAGE;
    if (requiredItems > transactions.length) {
      if (!hasMore) return;
      setPageLoading(true);
      await getData(currentPage);
      setPageLoading(false);
    }
    setUiPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Navigation to detail page (from first code) ────────────────────────────
  const navigatetotransaction = async (
    paymentMethod,
    metaDetails,
    date,
    time,
    bankCodeType,
    transaction_type,
    transactionid,
    status,
    credit_settled_amount,
    createdat,
    updatedat,
    contact_meta,
  ) => {
    setLoading(true);
    const token = sessionStorage.getItem('login_token');

    try {
      let uploadedDocuments = [];
      try {
        const encryptedPayload = await encryptPayload({
          transaction_id: transactionid,
          platform: 'web',
          extraParamValidation: 'trustedfromweb',
        });
        const docResp = await axios.post(
          Constants.BASE_URL + 'API-FX-196-GET-TRANSACTION-DOCUMENTS',
          encryptedPayload,
          {
            headers: {
              Authorization: 'Bearer ' + JSON.parse(token),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        );
        uploadedDocuments = docResp.data.documents || [];
      } catch (e) {
        console.log(e);
      }

      const chargeIds = Object.prototype.hasOwnProperty.call(
        JSON.parse(metaDetails),
        'charge_against_trx_id',
      )
        ? JSON.parse(metaDetails).charge_against_trx_id
        : [];
      settransactionIds(chargeIds);

      const parsedMeta = JSON.parse(metaDetails);
      const parsedContactMeta = (() => {
        try {
          return JSON.parse(contact_meta || '{}');
        } catch {
          return {};
        }
      })();
      const convMeta = parsedMeta.conversion_meta;
      const txCurrency =
        convMeta?.conversion_sell_currency ||
        parsedMeta.settled_currency ||
        parsedMeta.exchange_currency ||
        'GBP';
      const receive_currency =
        convMeta?.conversion_buy_currency ||
        parsedMeta.exchange_currency ||
        txCurrency;
      const symbol =
        txCurrency.length === 3 ? getCurrencySymbol(txCurrency) : txCurrency;
      const creditSettledAmount = `${symbol} ${credit_settled_amount}`;

      const buyAmountStr = convMeta
        ? getCurrencySymbol(convMeta.conversion_buy_currency) +
          ' ' +
          convMeta.conversion_client_buy_amount
        : parsedMeta.recipient_amount
          ? `${getCurrencySymbol(parsedMeta.exchange_currency || txCurrency)} ${parsedMeta.recipient_amount}`
          : creditSettledAmount;

      const sellAmountStr = convMeta
        ? getCurrencySymbol(convMeta.conversion_sell_currency) +
          ' ' +
          convMeta.conversion_client_sell_amount
        : `${symbol} ${credit_settled_amount}`;

      const sellCurrencyId =
        convMeta?.conversion_sell_currency === 'GBP' ? 231 : 231;
      const buyCurrencyId =
        convMeta?.conversion_buy_currency === 'INR' ? 105 : 105;
      const sellCurrencyIds = 231;
      const buyCurrencyIds = 105;

      const accountNumber =
        parsedMeta.second_beneficiary_bank_account_number ||
        parsedMeta.second_beneficiary_bank_iban ||
        '-';
      const bankCode =
        parsedMeta.second_beneficiary_bank_code ||
        parsedMeta.second_beneficiary_bank_bic ||
        parsedMeta.second_beneficiary_bank_bsb ||
        parsedMeta.second_beneficiary_bank_sort_code ||
        parsedMeta.second_beneficiary_bank_aba ||
        parsedMeta.second_beneficiary_bank_ifsc ||
        parsedContactMeta.ifsc_code ||
        parsedContactMeta.ifsc ||
        '-';

      const transactionList = JSON.parse(
        sessionStorage.getItem('transactionList') || '[]',
      );
      const matchedTxn =
        transactionList.find((item) => item.id === transactionid) || {};
      const txnData = {
        ...matchedTxn,
        last_transaction: matchedTxn,
        meta_data: parsedMeta,
      };
      const transferReason =
        parsedMeta.reason || parsedMeta.conversion_meta?.reason || '';
      const paymentReference = parsedMeta.reference || '';
      navigate('/TransactionListDetails', {
        state: {
          txn: txnData,
          formatteddate: date,
          formattedtime: time,
          transactionDetails: {
            id: transactionid,
            beneName: parsedMeta.second_beneficiary_name,
            date,
            time,
            transactionType: transaction_type,
            debittransactionId: transactionid,
            createdat,
            updatedat,
            sellAmount: sellAmountStr,
            send_MoneySendAmount: buyAmountStr,
            currency: txCurrency,
            receive_currency: receive_currency,
            status,
            reason: transferReason,
            reference: paymentReference,
            cardFees: parsedMeta.card_fees,
            beneficiaryName: parsedMeta.second_beneficiary_name,
            beneBankNumber: accountNumber,
            code: bankCode,
            senderName: parsedMeta.sender_name,
            beneBankType: bankCodeType,
            beneficiarybankType: '',
            creditAmount: creditSettledAmount,
            transactionIds: chargeIds,
            uploadedDocuments,
            paymentMethod,
            rawMeta: parsedMeta,
            sell_currency_country_id: sellCurrencyId
              ? sellCurrencyId
              : sellCurrencyIds,
            buy_currency_country_id: buyCurrencyId
              ? buyCurrencyId
              : buyCurrencyIds,
          },
        },
      });
    } catch (err) {
      console.error('Error navigating to transaction details:', err);
      toast.error('Failed to load transaction details.');
    } finally {
      setLoading(false);
    }
  };

  // function numberWithCommas(x) {
  //   return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // }

  // ── Download helpers (from first code) ────────────────────────────────────
  const downloadStatement = async () => {
    if (fromdate == '' || fromdate == null || todate == '' || todate == null) {
      toast.error('Please select from date and to date');
      return;
    }
    setdownloadLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    try {
      let resp;
      if (filtercurrency == '' || filtercurrency == null) {
        const encryptedPayload = await encryptPayload({
          start_date: fromdate,
          end_date: todate,
          workspace_id: login_workspaces_id,
          platform: 'web',
          extraParamValidation: 'trustedfromweb',
        });
        resp = await axios.post(
          Constants.BASE_URL + 'API-FX-203-DOWNLOAD-TRANSACTION-STATEMENT',
          encryptedPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        );
      } else {
        const encryptedPayload = await encryptPayload({
          start_date: fromdate,
          end_date: todate,
          workspace_id: login_workspaces_id,
          currency: filtercurrency,
          platform: 'web',
          extraParamValidation: 'trustedfromweb',
        });
        resp = await axios.post(
          Constants.BASE_URL +
            'API-FX-204-DOWNLOAD-TRANSACTION-CURRENCY-STATEMENT',
          encryptedPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        );
      }
      const docData = resp.data.document;
      const parsed =
        typeof docData === 'string' ? JSON.parse(docData) : docData;
      const url = parsed?.url;
      if (!url) {
        toast.error('Download URL not found. Please try again.');
        return;
      }
      window.open(url, '_blank');
      setshowdownload(false);
      setFromdate('');
      setTodate('');
    } catch (err) {
      console.error('PDF download error:', err);
      toast.error('Failed to download statement. Please try again.');
    } finally {
      setdownloadLoading(false);
    }
  };

  const downloadCSVStatement = async () => {
    if (fromdate == '' || fromdate == null || todate == '' || todate == null) {
      toast.error('Please select from date and to date');
      return;
    }
    setdownloadLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      if (filtercurrency == '' || filtercurrency == null) {
        const encryptedPayload = await encryptPayload({
          from_date: fromdate,
          to_date: todate,
          workspace_id: login_workspaces_id,
          platform: 'web',
          extraParamValidation: 'trustedfromweb',
        });
        const resp = await axios.post(
          Constants.BASE_URL + 'API-FX-229-DOWNLOAD-CSV-STATEMENT',
          encryptedPayload,
          {
            headers: {
              Authorization: 'Bearer ' + JSON.parse(login_token),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        );
        const url = resp.data.download_url;
        if (!url) {
          toast.error('Download URL not found. Please try again.');
          return;
        }
        window.open(url, '_blank');
        setshowdownload(false);
        setFromdate('');
        setTodate('');
      }
    } catch (err) {
      console.error('CSV download error:', err);
      toast.error('Failed to download CSV. Please try again.');
    } finally {
      setdownloadLoading(false);
    }
  };

  const downloadReceipt = async (id) => {
    setdownloadId(id);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    try {
      const encryptedPayload = await encryptPayload({
        id,
        workspace_id: login_workspaces_id,
        platform: 'web',
        extraParamValidation: 'trustedfromweb',
      });
      const resp = await axios.post(
        Constants.BASE_URL + 'API-FX-208-DOWNLOAD-TRANSACTION-RECEIPT',
        encryptedPayload,
        {
          headers: {
            'Content-Type': 'application/json',
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const docData = resp.data.document;
     
      const parsed =
        typeof docData === 'string' ? JSON.parse(docData) : docData;
      window.open(parsed?.url, '_blank');
         console.log('nnnnnnnn',parsed);

    } catch (e) {
      console.log(e);
    }
    setdownloadId(0);
  };

  const today = new Date().toISOString().split('T')[0];

  useEffect(() => {
    getBalances();
    beneficiaryList({ currencyid: 231, setBeneficiaries });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtercurrency]);

  const getBalances = async () => {
    setBalLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        Constants.BASE_URL +
          'API-FX-231-GET-WALLET-BALANCES/' +
          login_workspaces_id,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const balArray = Object.values(resp.data);
      setusedBalances(resp.data.used_balances);
      balArray.pop();
      setcurrencyCloudBalance(resp.data.currency_cloud_account_balance);
      setclearBankBalance(resp.data.clear_bank_account_balance);
      setclearBankConfiguration(resp.data.fees_configuration);
      balArray.pop();
      balArray.pop();
      balArray.pop();
      if (balArray.length > 0) {
        setBalances((balances) => [...balances, ...balArray]);
        if (balArray.length == 1) {
          balArray.push({
            id: 3,
            currency: 'INR',
            balance: 0,
            meta: {
              code: 'IN',
              name: 'India',
              country_id: 105,
              flag: 'https://uat.dhigna.com/flags/IN.PNG',
            },
            created_at: '2025-06-28T08:23:31.170932Z',
            updated_at: '2025-06-28T08:23:31.170935Z',
          });
        }
      } else {
        const defaultBank = sessionStorage.getItem('defaultBank');
        const parsedWorkspace = JSON.parse(
          sessionStorage.getItem('login_workspaces'),
        );
        var ref = '';
        if (defaultBank === 'Clear Bank as Service') {
          console.log('cb');
        } else {
          if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
            console.log('cc');
          } else {
            ref = JSON.parse(sessionStorage.getItem('login_workspaces'))[0]
              .memberships.urn;
            setreference(ref);
          }
        }
        if (ref != '') setBalances(Constants.INDIVIDUAL_BALANCES_CURRENCIES);
      }
      balArray.forEach((row) => {
        if (row.currency === 'GBP') {
          const used = usedBalances['GBP'] || 0;
          const final = row.balance - used;
          setBalance(final < 0 ? 0 : final);
        }
      });
      setBalLoading(false);
    } catch (err) {
      console.log(err.response.data);
      setBalLoading(false);
    } finally {
      setBalLoading(false);
    }
  };

  // ── Upload helpers (EXACTLY from first code) ───────────────────────────────
  const handleFileChange = (event, docName, txnId) => {
    const file = event.target.files[0];
    if (isFileTooLarge(file)) {
      toast.error(FILE_SIZE_ERROR);
      event.target.value = '';
      return;
    }
    setSelectedFiles((prev) => ({
      ...prev,
      [txnId]: {
        ...prev[txnId],
        [docName]: file,
      },
    }));
  };

  const handleUpload = (transaction_id) => {
    var counter = 1;
    const filesForTxn = selectedFiles[transaction_id] || {};

    if (Object.keys(filesForTxn).length === 0) {
      toast.error('Please select at least one file');
      return;
    }

    const docsForTxn = documents[transaction_id] || [];

    docsForTxn.forEach((doc) => {
      const file = filesForTxn[doc.document];
      if (!file) return;

      const reader = new FileReader();
      reader.onloadend = () => {
        setUploading(true);
        uploadDocument(
          transaction_id,
          doc.document_id,
          reader.result,
          file.name,
          counter,
        );
        counter++;
      };
      reader.readAsDataURL(file);
    });
  };

  const uploadDocument = async (
    transaction_id,
    document_id,
    document,
    filename,
    counter,
  ) => {
    var extension = filename.split('.');
    const token = sessionStorage.getItem('login_token');
    const encryptedPayload = await encryptPayload({
      transaction_id: transaction_id,
      document_id: document_id,
      document: document,
      extension: extension[extension.length - 1],
      platform: 'web',
      extraParamValidation: 'trustedfromweb',
    });

    await axios
      .post(
        Constants.BASE_URL + 'API-FX-194-UPLOAD-TRANSACTION-DOCUMENTS',
        encryptedPayload,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        console.log('uploaded' + resp);
        if (counter == documents[transaction_id].length) {
          toast.success('Uploaded Successfully.');
          setUploading(false);
          location.reload();
        }
      })
      .catch((err) => {
        toast.error('Something went wrong.Please try again later.');
        console.log('error' + err);
      });
  };

  // ── Style helpers ──────────────────────────────────────────────────────────
  const getStatusStyle = (s) => {
    const st = (s || '').toLowerCase();
    if (st === 'settled')
      return {
        bg: 'bg-emerald-50',
        color: 'text-emerald-700',
        label: 'Settled',
      };
    if (st === 'completed')
      return {
        bg: 'bg-emerald-50',
        color: 'text-emerald-700',
        label: 'Completed',
      };
    if (st === 'processing')
      return { bg: 'bg-blue-50', color: 'text-blue-700', label: 'Processing' };
    if (st === 'pending')
      return { bg: 'bg-red-50', color: 'text-red-700', label: 'Pending' };
    if (st === 'review')
      return { bg: 'bg-amber-50', color: 'text-amber-700', label: 'Review' };
    if (st === 'waiting for funds' || st === 'waiting for fund')
      return {
        bg: 'bg-red-50',
        color: 'text-red-700',
        label: 'Waiting for funds',
      };
    return { bg: 'bg-gray-100', color: 'text-gray-700', label: s };
  };

  const getIconBg = (type, status) => {
    if (type !== 'debit') {
      return type == null || type === '' || type === 'individual'
        ? 'bg-orange-50 text-orange-500'
        : 'bg-blue-50 text-blue-500';
    }
    const st = (status || '').toLowerCase();
    if (st === 'settled' || st === 'completed')
      return 'bg-emerald-50 text-emerald-600';
    if (st === 'processing') return 'bg-blue-50 text-blue-600';
    if (st === 'pending' || st === 'review') return 'bg-red-50 text-red-600';
    if (st === 'waiting for funds') return 'bg-red-50 text-red-600';
    return 'bg-emerald-50 text-emerald-600';
  };

  // ── Derived UI values ──────────────────────────────────────────────────────
  const noResultsFound = !loading && transactions.length === 0;
  const hasActiveFilters =
    searchText.date || searchText.status || searchText.type;
  const hasDateFilter = !!searchText.date;

  const STATUS_OPTIONS = (Constants.TRANSACTION_STATUS || []).map((status) => ({
    label: status,
    value: status.toLowerCase(),
  }));

  const PageSpinner = ({ message }) => (
    <div className="flex flex-col items-center justify-center py-20 gap-4">
      <div
        className="w-10 h-10 rounded-full border-4 border-gray-200"
        style={{
          borderTopColor: '#0B214E',
          animation: 'spin 0.75s linear infinite',
        }}
      />
      <p className="text-sm text-gray-400 font-medium">{message}</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
  PageSpinner.propTypes = { message: PropTypes.string };
  PageSpinner.defaultProps = { message: 'Loading transactions…' };

  // ── Render icon per row ────────────────────────────────────────────────────
  const renderIcon = (beneficiary) => {
    const st = (beneficiary.status || '').toLowerCase();
    if (beneficiary.type !== 'debit') {
      return beneficiary.type == null ||
        beneficiary.type === '' ||
        beneficiary.type === 'individual' ? (
        <MdOutlineCurrencyExchange size={17} />
      ) : (
        <FiArrowUpRight size={17} />
      );
    }
    if (st === 'settled' || st === 'completed')
      return <FiArrowUpRight size={17} />;
    if (st === 'processing')
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      );
    if (st === 'pending' || st === 'review')
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      );
    if (st === 'waiting for funds')
      return (
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 3h14" />
          <path d="M5 21h14" />
          <path d="M5 3a7 7 0 0 1 7 7" />
          <path d="M19 3a7 7 0 0 1-7 7" />
          <path d="M5 21a7 7 0 0 0 7-7" />
          <path d="M19 21a7 7 0 0 0-7-7" />
        </svg>
      );
    return <FiArrowUpRight size={17} />;
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f8fafc] via-[#eff6ff4d] to-[#eef2ff66] px-6 py-10 font-sans">
      <ToastContainer />

      {showdownload && (
        <div
          className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center"
          onClick={() => setshowdownload(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-2xl p-8 w-[370px] max-w-[95vw] shadow-2xl"
          >
            <h2 className="text-xl font-semibold text-[#1D2338] mb-1">
              Export Transaction History
            </h2>
            <p className="text-sm text-gray-500 mt-2 mb-6">
              Select a date range to download your transaction history
            </p>

            <div className="flex items-end gap-3 mb-6">
              {[
                {
                  label: 'From Date',
                  val: fromdate,
                  set: setFromdate,
                  min: undefined,
                  max: today,
                },
                {
                  label: 'To Date',
                  val: todate,
                  set: setTodate,
                  min: fromdate,
                  max: today,
                },
              ].map((f, i) => (
                <React.Fragment key={i}>
                  {i === 1 && (
                    <span className="text-gray-300 text-xl mb-2">→</span>
                  )}
                  <div className="flex-1">
                    <label className="text-[11px] text-gray-500 font-semibold uppercase tracking-wider block mb-1.5">
                      {f.label}
                    </label>
                    <div className="border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50">
                      <input
                        type="date"
                        min={f.min}
                        max={f.max}
                        value={f.val}
                        onChange={(e) => f.set(e.target.value)}
                        className="border-none outline-none bg-transparent text-sm text-gray-800 w-full font-sans"
                      />
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>

            {(filtercurrency == '' || filtercurrency == null) && (
              <div className="mb-7">
                <label className="text-[11px] text-gray-500 font-semibold uppercase tracking-wider block mb-3">
                  Format
                </label>
                <div className="flex gap-6">
                  {['pdf', 'csv'].map((fmt) => (
                    <label
                      key={fmt}
                      className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-800"
                    >
                      <input
                        type="radio"
                        name="downloadFormat"
                        value={fmt}
                        checked={downloadFormat === fmt}
                        onChange={() => setDownloadFormat(fmt)}
                        className="accent-orange-500 w-4 h-4"
                      />
                      {fmt.toUpperCase()}
                    </label>
                  ))}
                </div>
              </div>
            )}

            <div className="flex gap-3">
              <button
                onClick={() => {
                  setshowdownload(false);
                  setFromdate('');
                  setTodate('');
                }}
                className="flex-1 py-3 rounded-xl border border-gray-200 bg-white text-gray-600 font-semibold text-sm hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() =>
                  downloadFormat === 'csv'
                    ? downloadCSVStatement()
                    : downloadStatement()
                }
                disabled={downloadLoading}
                className="flex-1 py-3 rounded-xl border-none bg-orange-500 text-white font-bold text-sm hover:bg-orange-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {downloadLoading ? 'Downloading...' : 'Download'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Page Title ── */}
      <h1 className="text-center text-2xl font-bold text-[#1D2338] mb-6 tracking-tight">
        {filtercurrency ? `${filtercurrency} ` : ''}Transactions History
      </h1>

      {/* ── Outer Card ── */}
      <div
        style={{ maxWidth: width || '1024px' }}
        className="mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-6"
      >
        {/* ── Search Toolbar ── */}
        <div className="mb-4 space-y-3" ref={filterRef}>
          <div className="flex items-center gap-2 flex-wrap">
            {/* Combined search bar */}
            <div className="flex items-center bg-white border border-gray-200 rounded-xl px-3.5 h-10 gap-2 flex-1 min-w-[220px] focus-within:border-gray-400 transition-colors">
              <FiSearch size={13} className="text-gray-400 flex-shrink-0" />
              <input
                type="text"
                placeholder="Search by Account Name or Amount..."
                value={combinedSearch}
                onChange={(e) => handleCombinedSearchChange(e.target.value)}
                className="border-none outline-none text-[13px] text-gray-700 bg-transparent w-full placeholder-gray-400 font-sans"
              />
              {combinedSearch && (
                <button
                  onClick={clearCombinedSearch}
                  className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
                  title="Clear search"
                >
                  <FiX size={13} />
                </button>
              )}
            </div>

            {/* Download Statement */}
            <button
              onClick={() => setshowdownload(true)}
              className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white rounded-xl px-4 h-10 text-sm font-semibold whitespace-nowrap transition-colors flex-shrink-0"
            >
              <HiOutlineArrowDownTray size={15} />
              Download
            </button>

            {/* Advanced Filters toggle */}
            <button
              onClick={() => setShowFilterDropdown((v) => !v)}
              title="Advanced Filters"
              className={`flex items-center justify-center w-10 h-10 rounded-xl border transition-all flex-shrink-0 relative
               ${
                 showFilterDropdown ||
                 searchText.status ||
                 hasDateFilter ||
                 searchText.transactionId
                   ? 'border-[#0B214E] text-[#0B214E] bg-blue-50'
                   : 'border-gray-200 text-gray-500 bg-white hover:border-[#0B214E] hover:text-[#0B214E] hover:bg-blue-50'
               }`}
            >
              <FiFilter size={15} />
              {(searchText.status ||
                hasDateFilter ||
                searchText.transactionId) && (
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-orange-500 rounded-full border-2 border-white" />
              )}
            </button>
          </div>

          {/* ── Advanced Filters panel — full width, below the toolbar row ── */}
          {showFilterDropdown && (
            <div className="w-full bg-white border border-gray-200 rounded-xl p-4">
              <p className="text-[11px] font-semibold text-gray-500  tracking-wider mb-3">
                Advanced Filters
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                {/* Transaction ID */}
                {/* Transaction ID */}
                <div>
                  <label className="text-[11px] font-semibold text-gray-500 block mb-1.5">
                    Transaction ID
                  </label>
                  <div className="flex items-center border border-gray-200 rounded-lg px-3 h-10 focus-within:border-gray-400 transition-colors bg-gray-50">
                    <input
                      type="text"
                      placeholder="e.g. 4821"
                      value={searchText.transactionId}
                      onChange={(e) =>
                        handleTransactionIdChange(e.target.value)
                      }
                      className="border-none outline-none text-sm text-gray-700 bg-transparent w-full font-sans"
                    />
                  </div>
                </div>
                {/* Date */}
                <div>
                  <label className="text-[11px] font-semibold text-gray-500  tracking-wider block mb-1.5">
                    Date
                  </label>
                  <div className="flex items-center border border-gray-200 rounded-lg px-3 h-10 focus-within:border-gray-400 transition-colors bg-gray-50">
                    <input
                      type="date"
                      max={today}
                      value={searchText.date}
                      onChange={(e) => {
                        const newDate = e.target.value;
                        const newParams = { ...searchText, date: newDate };
                        setSearchText(newParams);
                        setTransactions([]);
                        setCurrentPage(0);
                        setHasMore(true);
                        setUiPage(1);
                        getData(0, newParams);
                      }}
                      className="border-none outline-none text-sm text-gray-700 bg-transparent w-full font-sans cursor-pointer"
                    />
                  </div>
                  {hasDateFilter && (
                    <button
                      onClick={() => {
                        const newParams = { ...searchText, date: '' };
                        setSearchText(newParams);
                        setTransactions([]);
                        setCurrentPage(0);
                        setHasMore(true);
                        setUiPage(1);
                        getData(0, newParams);
                        // setShowDateDropdown(false);
                      }}
                      className="mt-1.5 text-xs text-red-500 font-semibold hover:text-red-700 transition-colors"
                    >
                      Clear date
                    </button>
                  )}
                </div>
                {/* Status */}
                <div>
                  <label className="text-[11px] font-semibold text-gray-500  tracking-wider block mb-1.5">
                    Status
                  </label>
                  <select
                    value={searchText.status}
                    onChange={(e) => {
                      const newParams = {
                        ...searchText,
                        status: e.target.value,
                      };
                      setSearchText(newParams);
                      setTransactions([]);
                      setCurrentPage(0);
                      setHasMore(true);
                      setUiPage(1);
                      getData(0, newParams);
                    }}
                    className="w-full h-10 border border-gray-200 rounded-lg px-3 text-sm text-gray-700 bg-gray-50 outline-none focus:border-gray-400 transition-colors font-sans cursor-pointer"
                  >
                    <option value="" className="hidden">
                      Status
                    </option>
                    {STATUS_OPTIONS.map((opt) => (
                      <option
                        key={opt.value}
                        value={opt.value}
                        className="capitalize"
                      >
                        {opt.label}
                      </option>
                    ))}
                  </select>

                  {searchText.status && (
                    <button
                      onClick={() => {
                        const newParams = { ...searchText, status: '' };
                        setSearchText(newParams);
                        setTransactions([]);
                        setCurrentPage(0);
                        setHasMore(true);
                        setUiPage(1);
                        getData(0, newParams);
                      }}
                      className="mt-1.5 text-xs text-red-500 font-semibold hover:text-red-700 transition-colors"
                    >
                      Clear status
                    </button>
                  )}
                </div>
              </div>

              {(searchText.date ||
                searchText.status ||
                searchText.transactionId) && (
                <div className="flex justify-end border-t border-gray-100 pt-3">
                  <button
                    onClick={() => {
                      setCombinedSearch('');
                      const resetValues = {
                        transactionId: '',
                        date: '',
                        sender: '',
                        sendingAmount: '',
                        receivingAmount: '',
                        status: '',
                        type: '',
                      };
                      setSearchText(resetValues);
                      setTransactions([]);
                      setCurrentPage(0);
                      setHasMore(true);
                      setUiPage(1);
                      getData(0, resetValues);
                      setShowFilterDropdown(false);
                    }}
                    className="text-xs text-gray-500 font-semibold hover:text-gray-700 transition-colors"
                  >
                    Clear all filters
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Active filter chips */}
        {hasActiveFilters && (
          <div className="flex items-center gap-2 flex-wrap mb-3">
            {searchText.date && (
              <span className="flex items-center gap-1.5 bg-blue-50 text-[#0B214E] rounded-full px-3 py-1 text-xs font-semibold">
                Date: {searchText.date}
                <span
                  className="cursor-pointer font-bold text-sm opacity-60 hover:opacity-100 leading-none"
                  onClick={() => {
                    const newParams = { ...searchText, date: '' };
                    setSearchText(newParams);
                    setTransactions([]);
                    setCurrentPage(0);
                    setHasMore(true);
                    setUiPage(1);
                    getData(0, newParams);
                  }}
                >
                  ×
                </span>
              </span>
            )}
            {searchText.status && (
              <span className="flex items-center gap-1.5 bg-blue-50 text-[#0B214E] rounded-full px-3 py-1 text-xs font-semibold">
                Status:{' '}
                {STATUS_OPTIONS.find((o) => o.value === searchText.status)
                  ?.label || searchText.status}
                <span
                  className="cursor-pointer font-bold text-sm opacity-60 hover:opacity-100 leading-none"
                  onClick={() => {
                    const newParams = { ...searchText, status: '' };
                    setSearchText(newParams);
                    setTransactions([]);
                    setCurrentPage(0);
                    setHasMore(true);
                    setUiPage(1);
                    getData(0, newParams);
                  }}
                >
                  ×
                </span>
              </span>
            )}
            {searchText.type && (
              <span className="flex items-center gap-1.5 bg-blue-50 text-[#0B214E] rounded-full px-3 py-1 text-xs font-semibold">
                Type: {searchText.type}
                <span
                  className="cursor-pointer font-bold text-sm opacity-60 hover:opacity-100 leading-none"
                  onClick={() => {
                    const newParams = { ...searchText, type: '' };
                    setSearchText(newParams);
                    setTransactions([]);
                    setCurrentPage(0);
                    setHasMore(true);
                    setUiPage(1);
                    getData(0, newParams);
                  }}
                >
                  ×
                </span>
              </span>
            )}
            <button
              onClick={reset}
              className="text-red-500 font-semibold text-xs hover:text-red-700 transition-colors bg-transparent border-none cursor-pointer px-1"
            >
              Clear all
            </button>
          </div>
        )}

        {/* ── Transaction List ── */}
        {loading && transactions.length === 0 ? (
          <div className="rounded-xl border border-gray-200 overflow-hidden">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="h-[68px] border-b border-gray-100 last:border-b-0"
                style={{
                  background:
                    'linear-gradient(90deg,#f5f6f8 25%,#edeef0 50%,#f5f6f8 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 1.5s infinite',
                }}
              />
            ))}
            <style>{`@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}`}</style>
          </div>
        ) : pageLoading ? (
          <PageSpinner />
        ) : noResultsFound ? (
          <div className="text-center py-16 text-gray-400">
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              className="mx-auto mb-3 opacity-30"
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <p className="font-semibold text-sm text-gray-700 mb-1">
              No records found
            </p>
            <p className="text-xs">Try adjusting your search or filters.</p>
          </div>
        ) : (
          <>
            <div
              onMouseDown={(e) => e.stopPropagation()}
              className="rounded-xl border border-gray-200 overflow-hidden"
            >
              {paginatedTransactions.map((beneficiary, idx) => {
                const meta = (() => {
                  try {
                    return JSON.parse(beneficiary.meta || '[]');
                  } catch {
                    return {};
                  }
                })();
                const bankCodeType = meta?.type;
                const createddate = new Date(beneficiary.created_at);
                const isToday =
                  new Date().toDateString() === createddate.toDateString();
                const formatteddate = isToday
                  ? 'Today'
                  : createddate.getDate() +
                    '-' +
                    (createddate.getMonth() + 1) +
                    '-' +
                    createddate.getFullYear();
                const formattedtime = createddate.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                });

                const clientSellAmount =
                  meta.conversion_meta?.conversion_client_sell_amount;
                const clientSellAmountIcon =
                  meta.conversion_meta?.conversion_sell_currency;
                const senderNameVal =
                  beneficiary.type === 'debit'
                    ? meta.second_beneficiary_name
                    : meta.sender_name;
                let splittedSender =
                  beneficiary.settled_currency === 'EUR'
                    ? typeof senderNameVal === 'string'
                      ? senderNameVal.split(';')
                      : []
                    : typeof senderNameVal === 'string'
                      ? senderNameVal.split(';;')
                      : [];
                splittedSender = (splittedSender || []).map((name) =>
                  name
                    .toLowerCase()
                    .split(' ')
                    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                    .join(' '),
                );
                const displayName = splittedSender[0] || 'Unknown';
                const statusStyle = getStatusStyle(beneficiary.status);
                const isSettled = ['settled', 'completed'].includes(
                  String(beneficiary.status || '').toLowerCase(),
                );
                const isHovered = hoveredRow === beneficiary.id;
                const iconBgClass = getIconBg(
                  beneficiary.type,
                  beneficiary.status,
                );

                // const sendAmt = clientSellAmount
                //   ? `${numberWithCommas(parseFloat(clientSellAmount).toFixed(2))} ${clientSellAmountIcon || ''}`
                //   : `${numberWithCommas(parseFloat(beneficiary.amount).toFixed(2))} ${beneficiary.settled_currency || ''}`;
                
                const sendAmt = clientSellAmount
                  ? `${amountFormat(parseFloat(clientSellAmount).toFixed(2),clientSellAmountIcon)} ${clientSellAmountIcon || ''}`
                  : `${amountFormat(parseFloat(beneficiary.amount).toFixed(2),beneficiary.settled_currency)} ${beneficiary.settled_currency || ''}`;


                // Upload needed: transaction has docs assigned AND status is pending/review (from first code)
                const needsUpload =
                  beneficiary.id in documents &&
                  ['pending', 'review'].includes(
                    String(beneficiary.status || '').toLowerCase(),
                  );

                return (
                  <div key={beneficiary.id}>
                    <div
                      className={`flex items-center gap-3 px-4 py-3.5 border-b border-gray-100 last:border-b-0 transition-colors ${
                        isHovered
                          ? 'bg-blue-50/40'
                          : idx % 2 === 0
                            ? 'bg-white'
                            : 'bg-gray-50/60'
                      }`}
                      onMouseEnter={() => setHoveredRow(beneficiary.id)}
                      onMouseLeave={() => setHoveredRow(null)}
                      onClick={() =>
                        navigatetotransaction(
                          beneficiary.payment_method,
                          beneficiary.meta,
                          formatteddate,
                          formattedtime,
                          bankCodeType,
                          beneficiary.type,
                          beneficiary.id,
                          beneficiary.status,
                          beneficiary.amount,
                          beneficiary.created_at,
                          beneficiary.updated_at,
                          beneficiary.contact_meta,
                        )
                      }
                    >
                      {/* Icon */}
                      <div
                        className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${iconBgClass}`}
                      >
                        {renderIcon(beneficiary)}
                      </div>

                      {/* Name + meta */}
                      <div className="flex-1 min-w-0">
                        <div
                          className="font-semibold text-[13.5px] text-[#1D2338] cursor-pointer hover:text-[#0B214E] truncate max-w-[280px] mb-0.5"
                          onClick={() =>
                            navigatetotransaction(
                              beneficiary.payment_method,
                              beneficiary.meta,
                              formatteddate,
                              formattedtime,
                              bankCodeType,
                              beneficiary.type,
                              beneficiary.id,
                              beneficiary.status,
                              beneficiary.amount,
                              beneficiary.created_at,
                              beneficiary.updated_at,
                              beneficiary.contact_meta,
                            )
                          }
                        >
                          {displayName}
                        </div>
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="inline-block bg-gray-100 text-gray-500 rounded px-1.5 py-0.5 text-[10.5px] font-medium">
                            ID: {beneficiary.id}
                          </span>
                          <span className="text-[11px] text-gray-400">
                            {formatteddate} at {formattedtime}
                          </span>
                        </div>
                      </div>

                      {/* Amount + badge */}
                      <div className="text-right flex-shrink-0 min-w-[120px] flex flex-col items-end gap-1.5">
                        <div className="text-sm font-bold text-[#1D2338]">
                          {sendAmt}
                        </div>
                        {!(
                          isSettled &&
                          beneficiary.type === 'debit' &&
                          isHovered
                        ) && (
                          <span
                            className={`inline-flex items-center justify-center px-3 py-0.5 rounded-md text-[11.5px] font-semibold whitespace-nowrap min-w-[80px] ${statusStyle.bg} ${statusStyle.color}`}
                          >
                            {statusStyle.label}
                          </span>
                        )}
                      </div>

                      {/* Actions */}
                      <div className="flex items-center gap-1.5 flex-shrink-0">
                        {/* Send Again (hover on settled debit) */}
                        {isSettled &&
                          beneficiary.type === 'debit' &&
                          isHovered &&
                          account_type?.toLowerCase() === 'individual' && (
                            <button
                              className="flex items-center gap-1.5 bg-[#0B214E] hover:bg-[#162f6e] text-white rounded-full px-3.5 py-1.5 text-xs font-semibold whitespace-nowrap transition-colors"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigatetotransaction(
                                  beneficiary.payment_method,
                                  beneficiary.meta,
                                  formatteddate,
                                  formattedtime,
                                  bankCodeType,
                                  beneficiary.type,
                                  beneficiary.id,
                                  beneficiary.status,
                                  beneficiary.amount,
                                  beneficiary.created_at,
                                  beneficiary.updated_at,
                                  beneficiary.contact_meta,
                                );
                              }}
                            >
                              Repeat Again{' '}
                            </button>
                          )}

                        {/* Upload Documents (from first code logic) */}
                        {needsUpload && (
                          <>
                            {showUploadRow !== beneficiary.id ? (
                              <button
                                className="flex items-center gap-1.5 bg-white text-gray-600 border border-gray-200 hover:border-gray-400 hover:bg-gray-50 rounded-lg px-3 py-1.5 text-xs font-medium whitespace-nowrap transition-colors"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setShowUploadRow(beneficiary.id);
                                }}
                              >
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                  <polyline points="17 8 12 3 7 8" />
                                  <line x1="12" y1="3" x2="12" y2="15" />
                                </svg>
                                Upload Document
                              </button>
                            ) : null}
                          </>
                        )}

                        {/* View */}
                        <button
                          className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:bg-gray-100 hover:border-gray-400 hover:text-gray-800 transition-all flex-shrink-0"
                          title="View details"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigatetotransaction(
                              beneficiary.payment_method,
                              beneficiary.meta,
                              formatteddate,
                              formattedtime,
                              bankCodeType,
                              beneficiary.type,
                              beneficiary.id,
                              beneficiary.status,
                              beneficiary.amount,
                              beneficiary.created_at,
                              beneficiary.updated_at,
                              beneficiary.contact_meta,
                            );
                          }}
                        >
                          <FiEye size={13} />
                        </button>

                        {/* Download Receipt */}
                        <button
                          className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:bg-gray-100 hover:border-gray-400 hover:text-gray-800 transition-all flex-shrink-0"
                          title="Download Receipt"
                          onClick={(e) => {
                            e.stopPropagation();
                            downloadReceipt(beneficiary.id);
                          }}
                        >
                          {downloadId === beneficiary.id ? (
                            <MdDownloading size={14} />
                          ) : (
                            <HiOutlineArrowDownTray size={13} />
                          )}
                        </button>
                      </div>
                    </div>

                    {/* ── Upload panel (expanded inline, from first code) ── */}
                    {needsUpload && showUploadRow === beneficiary.id && (
                      <div
                        className={`px-4 py-4 border-b border-gray-100 ${
                          idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'
                        }`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="text-xs font-semibold text-gray-500 mb-3 uppercase tracking-wider">
                          Upload Required Documents
                        </p>
                        <div className="flex gap-3 flex-wrap">
                          {documents[beneficiary.id]?.map((doc, index) => (
                            <div
                              key={index}
                              className="border border-dashed border-blue-400 p-3 rounded-xl w-48 text-xs bg-blue-50/30"
                            >
                              {doc.uploaded_document ? (
                                <span className="text-emerald-600 font-semibold flex items-center gap-1.5">
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#16a34a"
                                    strokeWidth="2.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <polyline points="20 6 9 17 4 12" />
                                  </svg>
                                  {doc.document} uploaded
                                </span>
                              ) : (
                                <>
                                  <label className="font-semibold text-gray-700 block mb-2">
                                    {doc.document}
                                  </label>
                                  <input
                                    type="file"
                                    className="w-full text-[11px] text-gray-600 file:mr-2 file:py-1 file:px-2 file:rounded file:border-0 file:text-xs file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                                    onChange={(e) =>
                                      handleFileChange(
                                        e,
                                        doc.document,
                                        beneficiary.id,
                                      )
                                    }
                                  />
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                        <div className="flex items-center gap-2 mt-4">
                          <button
                            className="bg-blue-600 text-white px-4 py-1.5 rounded-lg text-xs font-semibold hover:bg-blue-700 disabled:opacity-60 transition-colors"
                            onClick={() => handleUpload(beneficiary.id)}
                            disabled={uploading}
                          >
                            {uploading ? 'Uploading...' : 'Submit'}
                          </button>
                          <button
                            className="bg-white text-gray-500 border border-gray-200 px-4 py-1.5 rounded-lg text-xs font-semibold hover:border-gray-400 transition-colors"
                            onClick={() => setShowUploadRow(null)}
                            disabled={uploading}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* ── Pagination ── */}
            {!fromHome && (
              <div className="flex items-center justify-end gap-1.5 pt-4 border-t border-gray-100 mt-1 flex-wrap">
                <button
                  className="flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 bg-white text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E] disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                  onClick={() => handlePageChange(uiPage - 1)}
                >
                  <FiChevronLeft size={13} />
                </button>

                {(() => {
                  const pages = [];
                  const range = 2;
                  let start = Math.max(1, uiPage - range);
                  let end = Math.min(totalPages, uiPage + range);
                  if (uiPage <= range + 1)
                    end = Math.min(totalPages, 2 * range + 1);
                  if (uiPage >= totalPages - range)
                    start = Math.max(1, totalPages - 2 * range);

                  if (start > 1) {
                    pages.push(
                      <button
                        key={1}
                        className="w-8 h-8 rounded-lg border border-gray-200 bg-white text-sm font-medium text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E] transition-all"
                        onClick={() => handlePageChange(1)}
                      >
                        1
                      </button>,
                    );
                    if (start > 2)
                      pages.push(
                        <span key="e1" className="px-1 text-gray-400 text-sm">
                          …
                        </span>,
                      );
                  }
                  for (let i = start; i <= end; i++) {
                    const isNextPageDisabled =
                      i > uiPage && !currentPageComplete;
                    pages.push(
                      <button
                        key={i}
                        onClick={() =>
                          !isNextPageDisabled && handlePageChange(i)
                        }
                        disabled={pageLoading || isNextPageDisabled}
                        className={`w-8 h-8 rounded-lg border text-sm font-medium transition-all
                          ${
                            uiPage === i
                              ? 'bg-[#0B214E] text-white border-[#0B214E] font-bold'
                              : isNextPageDisabled
                                ? 'border-gray-100 bg-gray-50 text-gray-300 cursor-not-allowed'
                                : 'border-gray-200 bg-white text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E]'
                          } disabled:opacity-50`}
                      >
                        {i}
                      </button>,
                    );
                  }
                  if (end < totalPages) {
                    if (end < totalPages - 1)
                      pages.push(
                        <span key="e2" className="px-1 text-gray-400 text-sm">
                          …
                        </span>,
                      );
                    pages.push(
                      <button
                        key={totalPages}
                        disabled={!currentPageComplete || pageLoading}
                        className={`w-8 h-8 rounded-lg border text-sm font-medium transition-all
                          ${
                            !currentPageComplete
                              ? 'border-gray-100 bg-gray-50 text-gray-300 cursor-not-allowed'
                              : 'border-gray-200 bg-white text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E]'
                          }`}
                        onClick={() =>
                          currentPageComplete && handlePageChange(totalPages)
                        }
                      >
                        {totalPages}
                      </button>,
                    );
                  }
                  return pages;
                })()}

                <button
                  className="flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 bg-white text-gray-600 hover:border-[#0B214E] hover:text-[#0B214E] disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                  onClick={() => handlePageChange(uiPage + 1)}
                >
                  <FiChevronRight size={13} />
                </button>

                <span className="text-xs text-gray-400 ml-2">
                  {(uiPage - 1) * ITEMS_PER_PAGE + 1}–
                  {Math.min(uiPage * ITEMS_PER_PAGE, transactions.length)} of{' '}
                  {transactions.length}
                  {hasMore ? '+' : ''}
                </span>
              </div>
            )}

            {/* View All — fromHome mode */}
            {fromHome && transactions.length > 5 && (
              <div className="text-right pt-3 border-t border-gray-100 mt-1">
                <button
                  onClick={() => navigate('/transactions')}
                  className="text-blue-700 font-semibold text-sm hover:text-blue-900 transition-colors bg-transparent border-none cursor-pointer"
                >
                  View All →
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Transaction;